import { render, staticRenderFns } from "./feedbackTrainer.vue?vue&type=template&id=44f95eb2&scoped=true"
import script from "./feedbackTrainer.vue?vue&type=script&lang=js"
export * from "./feedbackTrainer.vue?vue&type=script&lang=js"
import style0 from "./feedbackTrainer.vue?vue&type=style&index=0&id=44f95eb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f95eb2",
  null
  
)

export default component.exports